import { request } from './httpClient';

export interface UserProfile {
  id: number;
  first_name: string;
  surname: string;
  email: string;
  username: string;
  profile_picture: string | null;
  country_code: string;
  created_at: string;
}

export const userService = {
  getCurrentUser: () =>
    request<{ success: boolean; data: { user: UserProfile } }>('/v2/user/me.php', {
      method: 'GET'
    }),
  getStats: () =>
    request<{ success: boolean; data: { authorised_apps: number; connected_services: number | string; security_score: number; last_login: string } }>(
      '/v2/user/stats.php'
    ),
  getAuthorisedApps: (page?: number, per_page?: number) =>
    request<{ success: boolean; data: { apps: unknown[]; page: number; per_page: number; total: number; pages: number } }>(
      `/v2/user/authorised-apps.php${buildPagination(page, per_page)}`
    ),
  updateProfile: (payload: Record<string, string>) => {
    const formData = new FormData();
    Object.entries(payload).forEach(([key, value]) => formData.append(key, value));

    return request<{ success: boolean; data: { message: string } }>(
      '/v2/user/update-profile.php',
      {
        method: 'POST',
        body: formData
      }
    );
  },
  uploadProfilePicture: (file: File) => {
    const formData = new FormData();
    formData.append('avatar', file);

    return request<{ success: boolean; data: { message: string; avatar_100: string; avatar_500: string } }>(
      '/v2/user/upload-profile-picture.php',
      {
        method: 'POST',
        body: formData
      }
    );
  },
  getSecurityStatus: () =>
    request<{ success: boolean; data: { totp_enabled: boolean; totp_enabled_at?: string } }>('/v2/user/security/status.php'),
  changePassword: (payload: { current_password: string; new_password: string; new_password_repeat: string }) =>
    request<{ success: boolean; data: { message: string } }>(
      '/v2/user/security/change-password.php',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }
    ),
  enableTotp: (payload: { secret: string; code: string; password: string }) =>
    request<{ message: string; backup_codes: string[] }>(
      '/v2/user/security/enable-totp.php',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(payload)
      }
    ),
  disableTotp: (payload: { code: string; password: string }) =>
    request<{ message: string }>(
      '/v2/user/security/disable-totp.php',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(payload)
      }
    )
};

function buildPagination(page?: number, per_page?: number) {
  const params = new URLSearchParams();
  if (page) params.append('page', String(page));
  if (per_page) params.append('per_page', String(per_page));
  const query = params.toString();
  return query ? `?${query}` : '';
}
